import { Avatar, Box, Button, Flex, Image, Stack, Text } from "@mantine/core";
import { IconBook2, IconHistory, IconStarFilled, IconUser } from "@tabler/icons-react";


export default function _CourseList3({component}) {

	return (
		<Stack
			component="section"
			mx={component?.customize_styles?.general_decoration?.margin_x}
			my={component?.customize_styles?.general_decoration?.margin_y}
			bd={`${component?.customize_styles?.general_decoration?.border_width} solid ${component?.customize_styles?.general_decoration?.border_color}`}
			bg={component?.customize_styles?.general_decoration?.background_color}
			px={component?.customize_styles?.general_decoration?.padding_x}
			py={component?.customize_styles?.general_decoration?.padding_y}
			style={{
				borderRadius: parseInt(component?.customize_styles?.general_decoration?.border_radius),
				boxShadow: `${component?.customize_styles?.general_decoration?.shadow_offset_x}px ${component?.customize_styles?.general_decoration?.shadow_offset_y}px ${component?.customize_styles?.general_decoration?.shadow_blur_radius}px ${component?.customize_styles?.general_decoration?.shadow_blur_radius}px #00000014`,
			}}
		>
			{/* ---------- course list ---------- */}
			<Stack>
				{component?.items?.map((course) => (
					<Stack
						gap={10}
						key={course?.id}
						align="center"
						bg={component?.customize_styles?.box_decoration?.background_color}
						mx={component?.customize_styles?.box_decoration?.margin_x}
						my={component?.customize_styles?.box_decoration?.margin_y}
						px={component?.customize_styles?.box_decoration?.padding_x}
						py={component?.customize_styles?.box_decoration?.padding_y}
						bd={`${component?.customize_styles?.box_decoration?.border_width} solid ${component?.customize_styles?.box_decoration?.border_color}`}
						style={{
							borderRadius:
								component?.customize_styles?.box_decoration?.border_radius,
						}}
					>
						<Box
							pos="relative"
							lh={0}
							ta={component?.customize_styles?.image_decoration?.alignment}
						>
							<Image
								display="inline-block"
								src={course?.thumbnail}
								h={component?.customize_styles?.image_decoration?.height}
								w={component?.customize_styles?.image_decoration?.width ?? "100%"}
								fit={component?.customize_styles?.image_decoration?.boxfit}
								radius={component?.customize_styles?.image_decoration?.radius}
							/>
							{/* ------------ course price information --------- */}
							<Flex
								bg="#E7924D"
								h={60}
								w={60}
								pos="absolute"
								bottom={-20}
								right={10}
								gap={0}
								align="center"
								justify="center"
								style={{ borderRadius: "50%" }}
								direction="column"
							>
								<Text
									fs={
										component?.customize_styles?.sales_price_text_decoration
											?.font_style
									}
									fz={
										component?.customize_styles?.sales_price_text_decoration
											?.font_size
									}
									ff={
										component?.customize_styles?.sales_price_text_decoration
											?.font_family
									}
									fw={
										component?.customize_styles?.sales_price_text_decoration
											?.font_weight
									}
									c={
										component?.customize_styles?.sales_price_text_decoration
											?.color
									}
									lh={
										component?.customize_styles?.sales_price_text_decoration
											?.text_height
									}
									lts={
										component?.customize_styles?.sales_price_text_decoration
											?.letter_spacing
									}
									style={{
										textOverflow:
											component?.customize_styles?.sales_price_text_decoration
												?.text_overflow,
										textDecorationLine:
											component?.customize_styles?.sales_price_text_decoration
												?.text_decoration,
										textDecorationColor:
											component?.customize_styles?.sales_price_text_decoration
												?.decoration_color,
										textDecorationThickness:
											component?.customize_styles?.sales_price_text_decoration
												?.decoration_thickness,
									}}
								>
									${course?.course_price?.sale_price}
								</Text>
								<Text
									ta={
										component?.customize_styles?.regular_price_text_decoration
											?.text_align
									}
									ff={
										component?.customize_styles?.regular_price_text_decoration
											?.font_family
									}
									fs={
										component?.customize_styles?.regular_price_text_decoration
											?.font_style
									}
									fz={
										component?.customize_styles?.regular_price_text_decoration
											?.font_size
									}
									fw={
										component?.customize_styles?.regular_price_text_decoration
											?.font_weight
									}
									c={
										component?.customize_styles?.regular_price_text_decoration
											?.color
									}
									lh={
										component?.customize_styles?.regular_price_text_decoration
											?.text_height
									}
									lts={
										component?.customize_styles?.regular_price_text_decoration
											?.letter_spacing
									}
									style={{
										textDecorationLine:
											component?.customize_styles
												?.regular_price_text_decoration?.text_decoration,
										textDecorationColor:
											component?.customize_styles
												?.regular_price_text_decoration?.decoration_color,
										textDecorationThickness:
											component?.customize_styles
												?.regular_price_text_decoration
												?.decoration_thickness,
									}}
									mt={-4}
								>
									${course?.course_price?.regular_price}
								</Text>
							</Flex>
						</Box>
						<Flex w="100%">
							<Flex mt={16} gap={3} align="center" wrap="wrap">
								{course?.categories?.map((category) => (
									<Button
										key={category}
										variant="outline"
										h={28}
										fz={
											component?.customize_styles?.category_text_decoration
												?.font_size
										}
										c={
											component?.customize_styles?.category_text_decoration
												?.color
										}
										bg={"#fff"}
										bd={`1px solid #E1E4EA`}
										radius={4}
										fs={
											component?.customize_styles?.category_text_decoration
												?.font_style
										}
										fw={
											component?.customize_styles?.category_text_decoration
												?.font_weight
										}
										ff={
											component?.customize_styles?.category_text_decoration
												?.font_family
										}
										ta={
											component?.customize_styles?.category_text_decoration
												?.text_align
										}
										lh={
											component?.customize_styles?.category_text_decoration
												?.text_height
										}
										lts={
											component?.customize_styles?.category_text_decoration
												?.letter_spacing
										}
										style={{
											textDecorationLine:
												component?.customize_styles
													?.category_text_decoration?.text_decoration,
											textDecorationColor:
												component?.customize_styles
													?.category_text_decoration?.decoration_color,
											textDecorationThickness:
												component?.customize_styles
													?.category_text_decoration
													?.decoration_thickness,
										}}
									>
										{category}
									</Button>
								))}
							</Flex>
						</Flex>
						<Box w={"100%"}>
							<Text
								c={component?.customize_styles?.name_text_decoration?.color}
								ff={component?.customize_styles?.name_text_decoration?.font_family}
								fz={component?.customize_styles?.name_text_decoration?.font_size}
								fw={component?.customize_styles?.name_text_decoration?.font_weight}
								lh={component?.customize_styles?.name_text_decoration?.text_height}
								lts={
									component?.customize_styles?.name_text_decoration
										?.letter_spacing
								}
								lineClamp={2}
								style={{
									textOverflow:
										component?.customize_styles?.name_text_decoration
											?.text_overflow,
								}}
							>
								{course?.name}
							</Text>
							{/* ------- course review ------- */}
							<Flex my={14} align="center" gap={5}>
								<IconStarFilled color="#FEA055" size={17} />
								<Flex align="center" gap={3}>
									<Text
										c={
											component?.customize_styles?.rating_text_decoration
												?.color
										}
										fz={
											component?.customize_styles?.rating_text_decoration
												?.font_size
										}
										fw={
											component?.customize_styles?.rating_text_decoration
												?.font_weight
										}
										fs={
											component?.customize_styles?.rating_text_decoration
												?.font_style
										}
										ff={
											component?.customize_styles?.rating_text_decoration
												?.font_family
										}
										lh={
											component?.customize_styles?.rating_text_decoration
												?.text_height
										}
										lts={
											component?.customize_styles?.rating_text_decoration
												?.letter_spacing
										}
										style={{
											textOverflow:
												component?.customize_styles?.rating_text_decoration
													?.text_overflow,
										}}
									>
										{course?.rating}
									</Text>
									<Text c="#5E6066" size="12px">
										({course?.rating_count} reviews)
									</Text>
								</Flex>
							</Flex>
							{/* ------- course registration information --------- */}
							<Flex my={14} align="center" gap={8}>
								<Flex align="center" gap={4}>
									<IconBook2 color="#5E6066" size={18} />
									<Text c="#5E6066" size="14px">
										11 Lessons
									</Text>
								</Flex>
								<Flex align="center" gap={4}>
									<IconUser color="#5E6066" size={17} />
									<Text c="#5E6066" size="14px">
										{course?.total_students} Students
									</Text>
								</Flex>
							</Flex>

							{/* ------- course duration ------- */}
							<Flex my={14} align="center" gap={5}>
								<IconHistory color="#5E6066" size={17} />
								<Text c="#5E6066" size="14px">
									{course?.total_duration?.hours}h{" "}
									{course?.total_duration?.minutes}m{" "}
									{course?.total_duration?.seconds}s
								</Text>
							</Flex>
							{/* ----------- course author ---------- */}
							<Flex align="center" gap={5} mb={16}>
								<Avatar
									c={component?.customize_styles?.avatar_decoration?.color}
									h={component?.customize_styles?.avatar_decoration?.height}
									w={component?.customize_styles?.avatar_decoration?.width}
									src={course?.author?.avatar}
									radius={component?.customize_styles?.avatar_decoration?.radius}
								/>
								<Flex gap={4} align="center">
									<Text c="#5E6066" size="14px">
										By
									</Text>
									<Text
										ff={
											component?.customize_styles?.author_text_decoration
												?.font_family
										}
										fw={
											component?.customize_styles?.author_text_decoration
												?.font_weight
										}
										fz={
											component?.customize_styles?.author_text_decoration
												?.font_size
										}
										c={
											component?.customize_styles?.author_text_decoration
												?.color
										}
										lh={
											component?.customize_styles?.author_text_decoration
												?.text_height
										}
										lts={
											component?.customize_styles?.author_text_decoration
												?.letter_spacing
										}
										style={{
											textOverflow:
												component?.customize_styles?.author_text_decoration
													?.text_overflow,
										}}
									>
										{course?.author?.name}
									</Text>
								</Flex>
							</Flex>
						</Box>
					</Stack>
				))}
			</Stack>
		</Stack>
	);
}
